var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79559 11.6272V20H3.08371V11.6272H0V8.23225H3.08371V6.99704C3.08371 2.41124 4.93251 0 8.84426 0C10.0435 0 10.3433 0.199704 11 0.362426V3.72041C10.2648 3.58728 10.0578 3.51331 9.29396 3.51331C8.38741 3.51331 7.90201 3.77959 7.45944 4.30473C7.01687 4.82988 6.79559 5.73965 6.79559 7.04142V8.23965H11L9.87216 11.6346H6.79559V11.6272Z",
    fill: "#EE2D2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.ffb66ce7.svg";
export { ForwardRef as ReactComponent };